import {popperVariation, provideTippyConfig, provideTippyLoader, tooltipVariation} from '@ngneat/helipopper/config';

/** Single source of truth for the tippy setup — used by app.config.ts and by component specs. */
export function provideTippy() {
  return [
    provideTippyLoader(() => import('tippy.js')),
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: tooltipVariation,
        popper: popperVariation,
      },
    }),
  ];
}
